import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import DatePicker, { DateObject } from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
const Absent = ({ show, onClose }) => {
    const department = [
        { value: "1", label: "Management", },
        { value: "2", label: "Kitchen Management" },
        { value: "3", label: "Deliveri Mangement" },
    ];
    const staff = [
        { value: "1", label: "Siva Sakthi", },
        { value: "2", label: "Banu Priya" },
        { value: "3", label: "Deepak Kumar" },
    ];
    const options_del_point = [
        { value: "", label: "Select Delivery Point" },
        { value: "0", label: "Anna Nagar" },
        { value: "1", label: "Thallakulam" },
        { value: "2", label: "Anna Nagar" },
        { value: "3", label: "Thallakulam" },
    ];

    const format = "MM/DD/YY";


    const [selectedOption, setSelectedOption] = useState(null);
    const [isFocused] = useState(false);
    useEffect(() => {
        if (isFocused) {
            console.log('The input is focused!');
        }
    }, [isFocused]);

    return (
        <Modal show={show} size="md">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Mark Absent Attendance</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        {/* <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Date<span className="required">*</span></label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                <DatePicker
                                    format="DD-MM-YYYY"
                                    placeholder='Select Date'
                                />
                            </div>
                        </div> */}
                        {/* <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Department<span className="required">*</span></label>
                            <Select placeholder='Select Department'
                                onChange={setSelectedOption}
                                options={department}
                            />
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Staff<span className="required">*</span></label>
                            <Select placeholder='Select Staff'
                                onChange={setSelectedOption}
                                options={staff}
                            />
                        </div> */}
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Staff</label>
                            <label className='text-black fs-6 font-w500'>Priya</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Department</label>
                            <label className='text-black fs-6 font-w500'>Management</label>
                        </div>
{/* 
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Date<span className="required">*</span></label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                <DatePicker multiple
                                    format={format}
                                    placeholder='Select Date'
                                    className="date-picker-wrapper"
                                    plugins={[<DatePanel />]}
                                />
                            </div>
                        </div> */}
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Reason</label>
                            <textarea rows={8} className="form-control" name="comment" placeholder="Reason" defaultValue={""} />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
                        <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={onClose}>Mark Absent Attendance</Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Absent;
